import { AddressType } from '@mymsa/common'

export const addressTypeMap = {
  [AddressType.ADMIN]: 'Administration address',
  [AddressType.BUSINESS]: 'Business address',
  [AddressType.COLD_STORE]: 'Cold store address',
  [AddressType.DELIVERY]: 'Delivery address',
  [AddressType.EXPORT]: 'Export address',
  [AddressType.FACTORY]: 'Factory address',
  [AddressType.FEEDLOT]: 'Feedlot address',
  [AddressType.HEAD_OFFICE]: 'Head office address',
  [AddressType.LAIRAGE]: 'Lairage address',
  [AddressType.LEGAL]: 'Legal address',
  [AddressType.LIVESTOCK_OFFICE]: 'Livestock office address',
  [AddressType.MAIL_SERVICE]: 'Mail service address',
  [AddressType.OFFICE]: 'Office / registered address',
  [AddressType.PLANT]: 'Plant address',
  [AddressType.POSTAL]: 'Postal address',
  [AddressType.PROPERTY]: 'Property address',
  [AddressType.REGIONAL_OFFICE]: 'Regional office address',
  [AddressType.REGISTER]: 'Register address',
  [AddressType.RETAIL]: 'Retail address',
  [AddressType.SALES]: 'Sales address',
  [AddressType.SALEYARD]: 'Saleyard address',
  [AddressType.STATE_OFFICE]: 'State office address',
  [AddressType.WAREHOUSE]: 'Warehouse address',
  [AddressType.WHOLESALE]: 'Wholesale address'
}

export const addressTypeOptions = Object.entries(addressTypeMap).map(([value, text]) => ({ value, text }))
